import { render, staticRenderFns } from "./FormInstructionalMethod.vue?vue&type=template&id=5de0c698&"
import script from "./FormInstructionalMethod.vue?vue&type=script&lang=js&"
export * from "./FormInstructionalMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports